import * as React from 'react';
import { Auth } from 'firebase/auth';
import { EventBus } from '@/shared/utils';
import { SubscriptionEventKeys, SubscriptionEvents } from '../events';
import { Subscription } from '@/shared/i18n';
import { SubscriptionForm } from '../ui/subscription-form';
import { useSubscription } from '../hooks/use-subscription';

interface SubscriptionScreenProps {
  auth: Auth;
  eventBus: EventBus<SubscriptionEvents>;
  dict: Subscription;
}

const SubscriptionScreen: React.FC<SubscriptionScreenProps> = ({ auth, dict, eventBus }) => {
  const { updateSubscription, getCustomerSub, getSubs, cancelSubscription, createSubscription } =
    useSubscription(auth);

  const handleOpenPortalDo = React.useCallback(() => {
    eventBus.emit(SubscriptionEventKeys.payment.openPortal.init, undefined);
  }, [eventBus]);

  React.useEffect(() => {
    eventBus.on(SubscriptionEventKeys.subscription.update, updateSubscription);
    eventBus.on(SubscriptionEventKeys.subscription.view, getCustomerSub);
    eventBus.on(SubscriptionEventKeys.subscription.list, getSubs);
    eventBus.on(SubscriptionEventKeys.payment.openPortal.do, handleOpenPortalDo);
    eventBus.on(SubscriptionEventKeys.subscription.cancel, cancelSubscription);
    eventBus.on(SubscriptionEventKeys.subscription.create, createSubscription);

    return () => {
      eventBus.off(SubscriptionEventKeys.subscription.update, updateSubscription);
      eventBus.off(SubscriptionEventKeys.subscription.view, getCustomerSub);
      eventBus.off(SubscriptionEventKeys.subscription.list, getSubs);
      eventBus.off(SubscriptionEventKeys.payment.openPortal.do, handleOpenPortalDo);
      eventBus.off(SubscriptionEventKeys.subscription.cancel, cancelSubscription);
      eventBus.off(SubscriptionEventKeys.subscription.create, createSubscription);
    };
  }, [eventBus, updateSubscription, getCustomerSub, getSubs, handleOpenPortalDo]);

  return <SubscriptionForm dict={dict} eventBus={eventBus} />;
};

export default SubscriptionScreen;
